<template>
  <section>
    <div 
      class="py-24"
      :class="{
        'bg-primary-color': !getPrimaryColor,
        [`bg-[${getPrimaryColor}]`]: getPrimaryColor
      }"
    >
      <Container>
        <div class="flex flex-wrap flex-col md:flex-row gap-12">
          <ContactAgent
            v-if="getAgent"
            :data="getAgent"
          />
          <ContactAgent :data="agent" v-for="agent in getMultiAgents" :key="agent.id" />
        </div>
      </Container>
    </div>
    <div class="my-16">
      <Container>
        <div class="flex flex-col md:flex-row gap-y-12">
          <div class="w-full md:w-1/3">
            <svg class="mx-auto md:mx-0 w-8 h-8" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 11.25C17.5 11.913 17.2366 12.5489 16.7678 13.0178C16.2989 13.4866 15.663 13.75 15 13.75H7.5L2.5 18.75V5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H15C15.663 2.5 16.2989 2.76339 16.7678 3.23223C17.2366 3.70107 17.5 4.33696 17.5 5V11.25Z" stroke="#374364" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.5 11.25H25C25.663 11.25 26.2989 11.5134 26.7678 11.9822C27.2366 12.4511 27.5 13.087 27.5 13.75V27.5L22.5 22.5H15C14.337 22.5 13.7011 22.2366 13.2322 21.7678C12.7634 21.2989 12.5 20.663 12.5 20V18.75" stroke="#374364" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            <SectionHeader class="md:text-left mt-6! mb-0! leading-14">Any<br>questions?<br>Lets talk</SectionHeader>
          </div>
          <div class="w-full md:w-2/3">
            <ContactForm />
          </div>
        </div>
      </Container>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import ContactAgent from './components/ContactAgent';
  import ContactForm from './components/ContactForm';
  import Container from '../../components/Container';
  import addressMixin from '@/shared/mixins/address';

  export default {
    name: 'Contact',
    mixins: [
      addressMixin
    ],
    components: {
      SectionHeader,
      ContactAgent,
      ContactForm,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getAgent', 'getMultiAgents', 'getPrimaryColor'])
    }
  };
</script>
